import React, { useState, useEffect, Fragment } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import ModalUI from '../../../../shared/components/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

const no_op = () => { };
const Workplaces = ({ workplaces = [], loadWorkplaces = no_op }) => {
    const [workplaceName, setWorkplaceName] = useState('');
    const [onEdit, setOnEdit] = useState(false);
    const [workplaceToEdit, setWorkplaceToEdit] = useState({ id_sede: null, nombre: null });
    const [idtoDelete, setIdtoDelete] = useState(null);
    const [errors, setErrors] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });

    useEffect(() => {
        if (onEdit && workplaceToEdit) setWorkplaceName(workplaceToEdit.nombre);
    }, [workplaceToEdit.nombre])


    const validateForm = () => {
        let errorsByThisForm = {}
        let isThereAnError = false;

        if (workplaceName === '') {
            isThereAnError = true;
            errorsByThisForm.workplaceName = "Campo requerido"
        }

        setErrors(errorsByThisForm);
        return isThereAnError;
    }

    const saveWorkplace = async () => {
        if (validateForm()) return;
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'sedes/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ nombre: workplaceName })
        })
            .then(response => {
                console.log(response);
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then(data => {
                console.log({ data });
                setWorkplaceName('');
                setOpenAlert(true);
                setModalAlert({
                    message: "Guardado con exito",
                    color: 'success',
                    title: "Exitoso!"
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    const updateWorkplace = async () => {
        if (validateForm()) return;
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'sedes/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ nombre: workplaceName, id_sede: workplaceToEdit.id_sede })
        })
            .then(response => {
                console.log(response);
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then(data => {
                console.log({ data });
                setWorkplaceName('');
                setOpenAlert(true);
                setOnEdit(false)
                setModalAlert({
                    message: "Sede actualizada con éxito",
                    color: 'success',
                    title: "Exitoso!"
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const deleteWorkplace = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'sedes/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id: idtoDelete })
        })
            .then(response => {
                console.log(response);
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then(data => {
                console.log({ data });
                setOpenAlert(true);
                setOnEdit(false)
                setModalAlert({
                    message: "Sede eliminada con éxito",
                    color: 'success',
                    title: "Exitoso!"
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const onOkModal = () => {
        switch (modalAlert.color) {
            case "success":
                setOpenAlert(!openAlert);
                loadWorkplaces();
                break;
            case "warning":
                setOpenAlert(!openAlert);
                deleteWorkplace();
                break;
            default:
                setOpenAlert(!openAlert);
                break;
        }
    }

    return (
        <Fragment>
            <Row>
                <Col md={12}>
                    <div className='subtitle-general'>
                        <h4 style={{ margin: '0.25em 0em' }}>SEDES</h4>
                    </div>
                </Col>
            </Row>
            {!!workplaces.length ?
                <Row>
                    <Col md={12}>
                        <div className='flex-column-start'>
                            {workplaces.map(workplace => (
                                <div className='card-workplace ' key={workplace.id_sede}>
                                    <div>
                                        <h4 style={{ margin: '0.25em 0em' }}>{workplace.nombre}</h4>
                                    </div>
                                    <div className='flex-spac-bet-elem'>
                                        <div className='flex-row-center'>
                                            <Tooltip title="Editar">
                                                <IconButton
                                                    aria-label="print"
                                                    onClick={() => {
                                                        setOnEdit(true);
                                                        setWorkplaceToEdit(workplace);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faPenToSquare} />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div className='flex-row-center'>
                                            <Tooltip title="Eliminar">
                                                <IconButton
                                                    aria-label="print"
                                                    onClick={() => {
                                                        setIdtoDelete(workplace.id_sede);
                                                        setOpenAlert(true);
                                                        setOnEdit(false)
                                                        setModalAlert({
                                                            message: "Esta seguro de eliminar esta sede?",
                                                            color: 'warning',
                                                            title: "Advertencia!"
                                                        });
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
                : <p>No se ha configurado ninguna sede</p>
            }
            <Row>
                <Col md={8}>
                    <TextField
                        key={`nombre_sede`}
                        name={`nombre_sede`}
                        id="workplace_name"
                        style={{ width: '100%', margin: '0.5em 0em' }}
                        label="Nombre"
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' }
                        }}
                        value={workplaceName}
                        onChange={(e) => setWorkplaceName(e.target.value)}
                        error={errors.hasOwnProperty("workplaceName") ? errors.workplaceName !== "" : false}
                        helperText={errors.workplaceName}
                    />
                </Col>
                <Col md={4}>
                    <Button
                        style={{ marginTop: 20 }}
                        color="primary"
                        size='sm'
                        onClick={() => {
                            if (onEdit) {
                                updateWorkplace()
                            } else {
                                saveWorkplace();
                            }
                        }}
                    >
                        {onEdit ? "Actualizar Sede" : "Agregar Sede"}
                    </Button>
                </Col>
            </Row>
            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => onOkModal()}
                />
                : null}
        </Fragment>
    )
}
export default Workplaces